
export class ApplicationSetting {
  public id: string;
  public facebookLink: string;
  public facebookActive: boolean;

  public youTubeLink: string;
  public youTubeActive: boolean;

  public instagramLink: string;
  public instagramActive: boolean;

  public twitterLink: string;
  public twitterActive: boolean;

  public redditLink: string;
  public redditActive: boolean;

  public pinterestLink: string;
  public pinterestActive: boolean;

  public flickrLink: string;
  public flickrActive: boolean;

  public tumblrLink: string;
  public tumblrActive: boolean;

  public googleLink: string;
  public googleActive: boolean;

  public whatsAppLink: string;
  public whatsAppActive: boolean;
  
  public pricacyPolicyText: string;
  public shippingPolicyText: string;
  public homePageContent: string;

  public googleAppLink: string;
  public googleAppLinkIsActive: boolean;

  public appleAppLink: string;
  public appleAppLinkIsActive: boolean;

  public contentOneHeading: string;
  public contentOneDetail: string;
  public contentOneIcon: string;

  public contentTwoHeading: string;
  public contentTwoDetail: string;
  public contentTwoIcon: string;

  public contentThreeHeading: string;
  public contentThreeDetail: string;
  public contentThreeIcon: string;

  public contentFourHeading: string;
  public contentFourDetail: string;
  public contentFourIcon: string;

  public sectionOne: boolean = false;
  public sectionTwo: boolean = false;
  public sectionThree: boolean = false;

  public headingFrist: string ;
  public headingSecond: string ;
  public headingThird: string ;
}



// WEBPACK FOOTER //
// ./src/app/models/system-setting/application-setting.ts